import React from "react";
import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path d="M20.5 19a1 1 0 001-1V6a1 1 0 00-1-1h-10a1 1 0 00-1 1v12a1 1 0 001 1h10zM6.5 19a1 1 0 001-1V6a1 1 0 00-1-1h-3a1 1 0 00-1 1v12a1 1 0 001 1h3z" />
  </React.Fragment>,
  "ViewRightFocus"
);
